import util from './util';

export default (config, slotBidderCfg) => {
	return {
		'bidder': slotBidderCfg.bidder,
		'params': util.getParamsFromConfig(config, slotBidderCfg)
	};
};
